import { render, staticRenderFns } from "./TepSitioForm.vue?vue&type=template&id=0bf549ad"
import script from "./TepSitioForm.vue?vue&type=script&lang=js"
export * from "./TepSitioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports